import EventBus from "@/eventBus/eventBus.js";
import beasconfig from "@/api/beasconfig.js";

const mapcustomfences = {
    data() {
        return {
            search: "",
            selectIcon: 0,
            functionIconHeng: false,
            functionIconSu: false,
            timeout: null,
            holdAll: [
                //工具箱
                // {
                //   value: 0,
                //   label: "工具箱",
                //   img:require("@/assets/map/gjb.png"),
                //   imgBg:require("@/assets/map/gjb1.png")
                // },
                {
                    value: 1,
                    label: this.$t("message.Ranging"),
                    img: require("@/assets/map/cg.png"),
                    imgBg: require("@/assets/map/cg1.png"),
                },
                {
                    value: 2,
                    label: this.$t("message.Mark"),
                    img: require("@/assets/map/bz.png"),
                    imgBg: require("@/assets/map/bz1.png"),
                },
            ],
            holdAllIndex: 0,
            onLine: [
                //在线状态
                {
                    label: this.$t("message.all"),
                    value: 0,
                },
                {
                    label: this.$t("message.online"),
                    value: 1,
                },
                {
                    label: this.$t("message.offline"),
                    value: 2,
                },
            ],
            onLineNum: 1, //在线状态
            isShow: true, //显示 状态
            mapType: true, //地图显示类型
            isTraffic: false,
            holdAllvalue: this.$t("message.Toolbox"),
            openGb: false,
            dialogWidth: "956px", //对话框的宽度  50%
            dialogTableVisible: false,
            dialogTitle: "",
            location: {
                lng: "",
                lat: "",
            },
            ac: {},
            draw: {
                isPolygon: true,
                isCircular: false,
                isSquare: false,
            },
            xinextendUrlapi: beasconfig.xinextendUrlapi,
            isMark: true,
            alarmArr: [
                {
                    name: "SOS",
                    bg: require("@/assets/map/alarm_sos.png"),
                    bg1: require("@/assets/map/alarm_sos1.png"),
                },
                {
                    name: this.$t("message.fence"),
                    bg: require("@/assets/map/alarm_user.png"),
                    bg1: require("@/assets/map/alarm_user1.png"),
                },
            ],
            drawCz: [
                {
                    id: 2,
                    img: require("@/assets/draw3.png"),
                    img1: require("@/assets/draw4.png"),
                },
                {
                    id: 3,
                    img: require("@/assets/draw5.png"),
                    img1: require("@/assets/draw6.png"),
                }
            ],
            drawCzId: 0,
            drawImg: [
                {
                    id: 4,
                    img: require("@/assets/draw1.png"),
                    img1: require("@/assets/draw2.png"),
                },
                {
                    id: 6,
                    img: require("@/assets/draw7.png"),
                    img1: require("@/assets/draw8.png"),
                }
            ],
            drawImgId: 4
        }
    },
    methods: {
        clickMapMarkerIndex(index) {
            this.$store.state.mapMarkerIndex = index;
        },
        mapHoldall(e) {
            //改变地图
            // this.holdAllIndex = e;
            this.$refs.loanStatusSelect.visible = false;
            // EventBus.$emit("mapHoldall",e)
            if (e == 1) {
                this.$emit("changeMap", 5);
            } else if (e == 2) {
                this.$emit("changeMap", 6);
            }
        },
        changeValue(e) {
            //选中值
            this.$emit("switchOnlineState", e, this.onLine[e].label);
        },
        changeMap(type, bool) {
            //改变地图
            if (type == 1) {
                //改变地图状态
                this.isShow = !this.isShow;
                this.$emit("changeMap", type, this.isShow);
            } else if (type == 2) {
                //切换地图类型
                this.mapType = !this.mapType;
                this.$emit("changeMap", type, this.mapType);
            } else if (type == 3) {
                //创建交通流量图层实例
                this.isTraffic = !this.isTraffic;
                this.$emit("changeMap", type, this.isTraffic);
            } else if (type == 4) {
                //地图放大缩小
                this.$emit("changeMap", type, bool);
            }
        },
        bindSelect() {
            //选中
            if (this.$store.state.isCustom) {
                return;
            }
            this.functionIconHeng = !this.functionIconHeng;
            // this.$emit("openDrawing");
        },
        movedrawIcon(id) {
            this.drawCzId = id;
        },
        outdrawIcon() {
            this.drawCzId = 0;
        },
        getselectIcon(type, num) {
            // console.log("type", type);
            this.selectIcon = type;
            this.functionIconHeng = false;
            if (type >= 4) {
                this.drawImgId = type;
            }
            if (type >= 4 && this.$store.state.isCustom) {
                return;
            }
            if (type == 1) {
                this.functionIconHeng = true;
                this.functionIconSu = true;
                this.$emit("openDrawing");
            } else if (type == 2) {
                this.$store.state.isCustom = false;
                this.draw = {
                    isPolygon: true,
                    isCircular: false,
                    isSquare: false,
                };
                this.$emit("previousStep");
            } else if (type == 3) {
                this.$emit("deleteFenceArea");
            } else if (type == 4) {
                if (num == 1 && this.$store.state.isCustom) {
                    this.$store.state.isCustom = false;
                    this.$emit("openDrawing");
                } else {
                    this.$store.state.isCustom = true;
                    this.draw = {
                        isPolygon: true,
                        isCircular: false,
                        isSquare: false,
                    };
                    this.$emit("drawPolylines");
                }
            } else if (type == 5) {
                if (num == 1 && this.$store.state.isCustom) {
                    this.$store.state.isCustom = false;
                    this.$emit("openDrawing");
                } else {
                    this.$store.state.isCustom = true;
                    this.$emit("drawCircle");
                    this.draw = {
                        isPolygon: false,
                        isCircular: true,
                        isSquare: false,
                    };
                }
            } else if (type == 6) {
                if (num == 1 && this.$store.state.isCustom) {
                    this.$store.state.isCustom = false;
                    this.$emit("openDrawing");
                } else {
                    this.$store.state.isCustom = true;
                    this.draw = {
                        isPolygon: false,
                        isCircular: false,
                        isSquare: true,
                    };
                    this.$emit("drawRectangle");
                }
            }
        },
        oneselfPosition(row) {
            //当前位置
            EventBus.$emit("position", row);
            if (row) {
                this.isMark = false;
                this.$nextTick(() => {
                    this.isMark = true;
                });
            }
        },
        bindOpenGb(title) {
            //显示广播
            if (this.$store.state.isCustom) {
                return;
            }
            let groupArray = JSON.parse(sessionStorage.getItem("groupArray"));
            let array = groupArray.filter((item) => item.isRadioBroadcast == true);
            if (array && array.length < 1) {
                this.$MessageWarning(`请先开启接收广播的群组`);
            } else {
                this.$refs.dialogbox.openPg(2);
                this.openGb = true;
                this.dialogWidth = "956px";
                this.dialogTitle = title;
            }
            EventBus.$emit("emptyMap", 1);
        },
        query() { },
        createStateFilter(queryString) {
            return (state) => {
                return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        handleSelect(item) {
            console.log(item);
        }
    },
    created() {
        
    },
    beforeDestroy() {
       
    },
    mounted() {
      
    },
    watch: {

    }
}

export { mapcustomfences };